module.exports = __webpack_public_path__ + "img/python_icon.142c8f8b.svg";